import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: 'formly-field-input-group',
  templateUrl: './input-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldInputGroup extends FieldType {
  get type() {
    return this.props.type || 'text';
  }

  override defaultOptions = {
    props: {
      spinners: true,
      prependText: null,
      prependTextClass: 'input-group-text',
      appendText: null,
      appendTextClass: 'input-group-text',
      prependButtonText: null,
      prependButtonCommand: null,
      // CHAT-939: was 'btn btn-outline-secondary'. The template renders a Kendo
      // button now, so the default is a role rather than a class string.
      prependButtonThemeColor: 'base',
      appendButtonText: null,
      appendButtonCommand: null,
      appendButtonThemeColor: 'base',
    },
  };

  onValueChange(event) {
    if (this.props.change) {
      this.props.change(this.field, event);
    }
  }

  onPrependButtonClick() {
    if (this.props.prependButtonCommand && typeof this.props.prependButtonCommand === 'function') {
      this.props.prependButtonCommand(this.field, this.formControl.value);
    }
  }

  onAppendButtonClick() {
    if (this.props.appendButtonCommand && typeof this.props.appendButtonCommand === 'function') {
      this.props.appendButtonCommand(this.field, this.formControl.value);
    }
  }
}
